import { UserToken } from "@typings/Reactions";
import { v7 as uuidv7 } from "uuid";
import { create } from "zustand";

/**
 * This global state storage is used for mySPH login user data.
 */
export interface UserVarStore {
  userToken: UserToken;
  deviceId: string | null;
  isAnalyticsInitialized: boolean;
  setUserToken: (userToken: UserToken) => void;
  setAnalyticsInitialized: (isInitialized: boolean) => void;
}

let deviceId: string | null;

if (typeof window !== "undefined") {
  deviceId = localStorage.getItem("device_id");

  if (!deviceId) {
    deviceId = uuidv7();
    localStorage.setItem("device_id", deviceId);
  }
}

const useUserVarStore = create<UserVarStore>((set) => ({
  userToken: {
    type: "device_id",
    id: deviceId,
  },
  deviceId,
  isAnalyticsInitialized: false,
  setUserToken: (userToken) => {
    set({ userToken });
  },
  setAnalyticsInitialized: (isInitialized) => {
    set({ isAnalyticsInitialized: isInitialized });
  },
}));

export default useUserVarStore;
